import { FC } from 'react'
import { faTimes } from '@document-crunch/pro-regular-svg-icons'
import { Icon, IconColor, Button } from '@/dc-shared-web/src'
import clsx from 'clsx'
import { getFileIconByExtension } from '@/app/(dashboard)/upload/utils/getFileIconByExtension'

export type FileItemProps = {
  /** Error message to display. It also serves as a flag to display the error border. */
  errorMessage?: string
  /** File to display. */
  file: File
  /** Loading state to disable interactions and reduce opacity. */
  isLoading?: boolean
  /** Callback to remove the file. */
  onRemove: () => void
}

export const FileItem: FC<FileItemProps> = ({
  errorMessage,
  file,
  isLoading,
  onRemove,
}) => {
  const icon = getFileIconByExtension(file)

  return (
    <div className='tw-space-y-2'>
      <div
        className={clsx(
          'tw-flex tw-items-center tw-gap-4 tw-pl-4 tw-pr-2 tw-py-2 tw-border tw-rounded-lg',
          errorMessage
            ? 'tw-border-destructive tw-border-solid'
            : 'tw-border-dashed tw-border-blue-300',
          isLoading && 'tw-opacity-50'
        )}
      >
        <Icon icon={icon} color={IconColor.tertiary} size='2xl' />
        <p className='tw-flex-1 tw-text-sm tw-text-gray-900 tw-break-all'>
          {file.name}
        </p>
        <Button
          onClick={onRemove}
          variant='ghost'
          size='icon'
          aria-label='Remove file'
          data-testid='remove-file'
          disabled={isLoading}
        >
          <Icon icon={faTimes} />
        </Button>
      </div>
      {errorMessage && (
        <p
          className='tw-text-destructive tw-text-sm'
          data-testid='file-item-error-message'
        >
          {errorMessage}
        </p>
      )}
    </div>
  )
}
